'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.intersectionOfObjects = undefined;

var _ = require('_');

var intersectionOfObjects = exports.intersectionOfObjects = function intersectionOfObjects(a, b) {
  var results = a.filter(function (aElement) {
    var existsInB = (0, _.some)(b, function (bElement) {
      return (0, _.isEqual)(aElement, bElement);
    });
    return existsInB;
  });
  return results;
};


//////////////////
// WEBPACK FOOTER
// ./js/utils/intersectionOfObjects.js
// module id = 516
// module chunks = 3 4 5